import {
  BED_SIZE_PRODUCT_OPTION_ID,
  orientationOptionIds,
  SIZE_PRODUCT_OPTION_ID,
} from 'commons/constants';

const CONFIGURATION_PRODUCT_OPTION_IDS = [
  ...orientationOptionIds,
  BED_SIZE_PRODUCT_OPTION_ID,
  SIZE_PRODUCT_OPTION_ID,
];

const getConfigurationOptionValueIds = selectedOptionsExtended => {
  if (!selectedOptionsExtended) {
    return [];
  }

  return CONFIGURATION_PRODUCT_OPTION_IDS.map(
    optionId => selectedOptionsExtended[optionId]?.value?.id
  )
    .filter(optionValueId => optionValueId != null)
    .map(optionValueId => parseInt(optionValueId, 10))
    .filter(Boolean);
};

export default getConfigurationOptionValueIds;
